/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"

import { css, Global } from "@emotion/core"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Global
        styles={css`
          *,
          *:before,
          *:after {
            box-sizing: border-box;
          }

          html,
          body {
            -webkit-overflow-scrolling: touch;
          }

          body {
            font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue",
              Helvetica, "Segoe UI", "ヒラギノ角ゴシック Pro",
              "Hiragino Kaku Gothic Pro", "Hiragino Sans", "メイリオ", Meiryo,
              Osaka, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
            background-color: #000000;
            background-image: linear-gradient(
              270deg,
              #000000 0%,
              #111056 35%,
              #350854 70%,
              #000000 100%
            );
            text-align: center;
          }
        `}
      />
      <Header siteTitle={data.site.siteMetadata.title} />
      <div
        style={{
          margin: `0`,
          padding: `0`,
        }}
      >
        <main>{children}</main>
        <Footer />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
